import styled from "styled-components";
export const ActivityWrapper = styled.div`
  .actions {
    .img-holder {
      padding: 0px 5px 0px 5px !important;
      img {
        border: 1px solid #d5d5d5;
        background-color: ${({ theme }) => theme.box};
        height: 50px;
      }
      @media (min-width: 1200px) {
        img {
          height: 50px !important;
        }
      }
    }
    .card-holder {
      padding: 0px 5px 0px 5px !important;
      border-radius: 5px;
      .card- {
        background-color: ${({ theme }) => theme.box};
        width: 100%;
        min-height: fit-content;
        padding-top: 10px;
        .part-1 {
          padding: 0px 5px;
          position: relative;
          .checkmark {
            font-size: 24px;
            color: ${({ theme }) => theme.text};
            margin-left: 5px;
          }
          .title {
            margin-right: 5px;
          }
          .actions {
            position: absolute;
            left: 0px;
            h6 {
              color: #000;
              box-shadow: none;
            }
            .threedots {
              font-size: 24px;
              margin-left: 5px;
            }
            .content {
              background-color: ${({ theme }) => theme.box};
              position: absolute;
              color: ${({ theme }) => theme.text};
              box-shadow: ${({ theme }) => theme.shadow};
              left: 5px;
              top: 30px;
              border-radius: 5px;
              width: 240px;
              height: fit-content;
              .collapse-content {
                padding: 15px !important;
                .collapse-item {
                  margin-bottom: 5px;
                  svg {
                    font-size: 24px;
                    margin-left: 4px;
                  }
                  .action-done {
                    color: #359761;
                  }
                  .action-not-done {
                    color: #f1416c;
                  }
                }
              }
            }
          }
          .recorddate {
            color: #6f5959 !important;
          }
        }
        .part-2 {
          padding: 10px 5px;
          margin-top: 5px;
          background-color: ${({ theme }) => theme.body};
          border: 1px solid #ccc !important;
          .action-answer {
            padding: 0.5rem;
          }
          .answer-record {
            color: #6f5959 !important;
          }
        }
        .part-3 {
          .comment-item {
            border-bottom: 1px dashed ${({ theme }) => theme.border} !important;
            padding: 10px;
            .img-holder {
              img {
                border: 1px solid #d6d6d6;
                height: 40px;
              }
            }
            .content-holder {
              padding-right: 10px;
              .comment-record-date {
                color: #6f5959;
              }
            }
          }
          .add-comment {
            border-bottom: 1px dashed ${({ theme }) => theme.border} !important;
            padding: 10px;

            .content-holder {
              padding-right: 10px;
              textarea {
                background-color: ${({ theme }) => theme.body};
                resize: none;
                border: none;
                font-size: 14px;
                height: 60px;

                &:focus {
                  box-shadow: none;
                }
              }
              button {
                height: 40px;
              }
            }
          }
        }
      }
    }
  }
`;
